import React from 'react';
import AppFooter from './AppFooter/AppFooter.component';
import AppHeadings from './AppHeadings/AppHeadings.component';
import { Outlet } from 'react-router-dom';

const AppLayout = () => {
  return (
    <>
      <AppHeadings/>
      <Outlet/>
      <AppFooter/>
    </>
  )
}
export default AppLayout;